package one.healthium.notifications.manager

actual class NotificationManager {
    actual fun showNotification(notification: Notification) {
    }
}